
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/accessibility",
      function () {
        return require("private-next-pages/de/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/accessibility"])
      });
    }
  